import { LoadingServiceMap } from './src/service'
import Loading from './src/loading.vue'

import type { App } from 'vue'

// installer and everything in all

Loading.install = (app: App) => {
  app.component(Loading.name, Loading)
  app.config.globalProperties.$loading = Loading
}

Loading.show = LoadingServiceMap.show
Loading.hide = LoadingServiceMap.hide

export default Loading

export const SgLoading = Loading

export * from './src/types'

export * from './src/loading'
